<template>
    <div class="container mx-auto px-4 py-8 mb-24">
        <div class="flex flex-col-reverse lg:flex-row justify-between">

            <!-- Table Section -->
            <div class="w-full lg:w-2/3">
                <h2 class="text-xl font-bold mb-6 text-gray-700">Record Scores</h2>
                <div
                    class="flex flex-col md:flex-row items-center justify-around gap-4 mb-6 bg-gray-700 md:h-14 rounded-md">
                    <div class="flex items-center font-semibold text-xl text-white">
                        Subject: COMP/ICT
                    </div>
                    <div class="flex items-center gap-5">
                        <h2 class="font-semibold text-xl text-white">Class: JS2</h2>
                        <h2 class="font-semibold text-xl text-white">Section: A</h2>
                    </div>
                </div>
                <div class="flex flex-col md:flex-row md:items-center md:gap-2 gap-2 mb-6">
                    <div class="flex items-center">
                        <label class="text-xl font-semibold text-gray-700 mr-2">Filter</label>
                        <input type="text"
                            class="bg-gray-50 border border-gray-300 focus:border-gray-600 outline-none py-3 px-3 w-full md:w-72 text-gray-700 text-sm rounded-md"
                            placeholder="Type to search..." required>
                        <button type="submit"
                            class="ml-2 py-3 px-3 text-sm font-medium text-white bg-gray-400 rounded-md">Clear</button>
                    </div>
                    <div class="flex items-center">
                        <label class="text-lg font-semibold text-gray-700 mr-2 whitespace-nowrap">Per Page</label>
                        <input type="number"
                            class="bg-gray-50 border border-gray-300 focus:border-gray-600 outline-none py-3 px-3 w-full md:w-64 text-gray-700 text-sm rounded-md"
                            required>
                    </div>
                </div>
                <div class="bg-gray-50 shadow-lg rounded-xl overflow-x-auto">
                    <table class="min-w-full bg-white rounded-xl">
                        <thead class="bg-gray-700 text-white h-14">
                            <tr>
                                <th class="px-4 py-2 text-left text-md font-semibold">Students</th>
                                <th class="px-4 py-2 text-center text-md font-semibold">Matric No</th>
                                <th class="px-4 py-2 text-center text-md font-semibold">Test One</th>
                                <th class="px-4 py-2 text-center text-md font-semibold">Test Two</th>
                                <th class="px-4 py-2 text-center text-md font-semibold">Test Three</th>
                                <th class="px-4 py-2 text-center text-md font-semibold">Exam</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-b hover:bg-gray-50">
                                <td class="px-4 py-4  text-lg whitespace-nowrap">Adeloba Joshua</td>
                                <td class="px-4 py-4 text-center  text-lg">FIHS/20/2024</td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>

                            </tr>
                            <tr class="border-b hover:bg-gray-50">
                                <td class="px-4 py-4  text-lg whitespace-nowrap">Adeloba Joshua</td>
                                <td class="px-4 py-4 text-center  text-lg">FIHS/20/2024</td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>

                            </tr>
                            <tr class="border-b hover:bg-gray-50">
                                <td class="px-4 py-4  text-lg whitespace-nowrap">Adeloba Joshua</td>
                                <td class="px-4 py-4 text-center  text-lg">FIHS/20/2024</td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>
                                <td class="px-4 py-4 text-center"><input type="number"
                                        class="w-16 py-2 border border-gray-700 rounded-lg text-center" /></td>

                            </tr>
                            
                            <!-- Add more rows as needed -->
                        </tbody>
                    </table>
                </div>

                <div class="flex justify-center mt-6">
                    <nav class="flex items-center space-x-2">
                        <button
                            class="px-3 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-indigo-100 transition duration-300">
                            <span class="sr-only">Previous</span>
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                        <button class="px-4 py-2 bg-gray-700 text-white font-semibold rounded-lg">1</button>
                        <button
                            class="px-4 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-indigo-100 transition duration-300">2</button>
                        <button
                            class="px-4 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-indigo-100 transition duration-300">3</button>
                        <button
                            class="px-3 py-2 border border-gray-700 text-gray-700 rounded-lg hover:bg-indigo-100 transition duration-300">
                            <span class="sr-only">Next</span>
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </nav>
                </div>
            </div>

            <!-- Form Section -->
            <div class="w-full md:w-96 bg-gray-50 rounded-xl shadow-lg">
                <div>
                    <div class="flex items-center justify-between gap-5 bg-gray-700 w-full p-4 rounded-md">
                        <div class="font-semibold text-xl text-white">{{ labels.SUBJECT }}</div>
                        <div class="font-semibold text-xl text-white">Classroom(Section)</div>
                    </div>
                    <div class="flex items-center justify-between   w-full p-4 rounded-md">
                        <div class="font-semibold text-xl text-gray-700 ">
                            <h2>COMP/ICT</h2>
                         
                        </div>
                        <div class="grid grid-cols-2 gap-4 font-semibold text-lg text-gray-700 ">
                            <button class=" px-2 bg-gray-700 text-white whitespace-nowrap rounded-md">JS3 A</button>
                            <button class=" px-2 bg-gray-700 text-white whitespace-nowrap rounded-md">JS3 B</button>
                            <button class=" px-2 bg-gray-700 text-white whitespace-nowrap rounded-md">JS3 C</button>
                            <button class=" px-2 bg-gray-700 text-white whitespace-nowrap rounded-md">SS1 Art</button>
                            <button class=" px-2 bg-gray-700 text-white whitespace-nowrap rounded-md">SS2 Com</button>
                            <button class=" px-2 bg-gray-700 text-white whitespace-nowrap rounded-md">SS3 Sci</button>
                        </div>
                    </div>                </div>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { useSchoolLabels } from '@/composables/useSchoolLabels';

const { labels: labelsRef } = useSchoolLabels();
const labels = computed(() => labelsRef.value);
</script>

<style lang="scss" scoped></style>
